// extracted by css-extract-rspack-plugin
export default {"markdown":"VPTp95CblXQIBv0Y__markdown___"};